/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

(function (root, doc) {
  'use strict';
  function en(pl, eng) { return /^en(?:-|$)/i.test(doc.documentElement.lang || '') ? eng : pl; }
  function randomInt(max) {
    if (root.crypto && root.crypto.getRandomValues) {
      var a = new Uint32Array(1), limit = 4294967296 - (4294967296 % max);
      do { root.crypto.getRandomValues(a); } while (a[0] >= limit);
      return a[0] % max;
    }
    return Math.floor(Math.random() * max);
  }
  function clear(el) { while (el && el.firstChild) el.removeChild(el.firstChild); }
  function node(tag, cls, text) { var x = doc.createElement(tag); if (cls) x.className = cls; if (text !== undefined) x.textContent = text; return x; }
  function init(box) {
    var pool = Number(box.dataset.pula), pick = Number(box.dataset.typuje), select = box.querySelector('[data-model-n]');
    var button = box.querySelector('[data-model-run]'), status = box.querySelector('[data-model-status]'), out = box.querySelector('[data-model-wynik]');
    button.addEventListener('click', function () {
      var total = Number(select.value) || 1000, counts = new Array(pool).fill(0), done = 0, base = [];
      for (var x = 1; x <= pool; x++) base.push(x);
      button.disabled = true; clear(out); out.hidden = true; status.textContent = jst("pages_symulator_modelu_js.777dd7af3f83");
      function chunk() {
        var end = Math.min(total, done + 250);
        for (; done < end; done++) {
          var draw = base.slice();
          for (var i = 0; i < pick; i++) { var j = i + randomInt(pool - i), t = draw[i]; draw[i] = draw[j]; draw[j] = t; counts[draw[i] - 1]++; }
        }
        if (done < total) { root.setTimeout(chunk, 0); return; }
        var p = pick / pool, expected = total * p, sd = Math.sqrt(total * p * (1 - p));
        var rows = counts.map(function (hits, i) { return { n: i + 1, hits: hits, z: sd ? (hits - expected) / sd : 0 }; });
        rows.sort(function (a, b) { return Math.abs(b.z) - Math.abs(a.z) || a.n - b.n; });
        var intro = node('p', 'tekst-maly', jst("pages_symulator_modelu_js.780a50128d26") + expected.toFixed(1) + '. ' + jst("pages_symulator_modelu_js.d12e7caa5083"));
        var wrap = node('div', 'tabela-scroll'), table = node('table', 'tabela'), cap = node('caption', '', jst("pages_symulator_modelu_js.672e43e7073e"));
        var head = node('thead'), hr = node('tr'); [jst("pages_symulator_modelu_js.c52929997cb4"), jst("pages_symulator_modelu_js.3d7db62db2fa"), jst("pages_symulator_modelu_js.67bcb3a8316e"), 'z'].forEach(function (v) { hr.appendChild(node('th', '', v)); }); head.appendChild(hr);
        var gra = box.dataset.gra || '';
        // Liczba jako kula w kolorze gry (22.09.2026, daro) — jak w tabelach wynikow.
        var body = node('tbody'); rows.slice(0, 10).forEach(function (r) { var tr = node('tr'); var th = node('th'); th.scope = 'row'; th.setAttribute('data-sort', String(r.n)); th.appendChild(node('span', "kula kula--mala" + (gra ? ' kula--' + gra : ''), String(r.n))); tr.appendChild(th); tr.appendChild(node('td', 'liczbowa', String(r.hits))); tr.appendChild(node('td', 'liczbowa', expected.toFixed(1))); tr.appendChild(node('td', 'liczbowa', r.z.toFixed(2))); body.appendChild(tr); });
        table.appendChild(cap); table.appendChild(head); table.appendChild(body); wrap.appendChild(table); out.appendChild(intro); out.appendChild(wrap);
        out.appendChild(node('p', 'tekst-maly', jst("pages_symulator_modelu_js.f9c58fcb7c88")));
        out.hidden = false; status.textContent = jst("pages_symulator_modelu_js.7b7ae1202b46") + total + jst("pages_symulator_modelu_js.47c168d19d0f"); button.disabled = false;
      }
      chunk();
    });
  }
  function start() { doc.querySelectorAll('[data-model-simulator]').forEach(init); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
})(window, document);
